import type { ProfitRole } from '@/types/profitSettings'

interface Props {
  open: boolean
  positionName: string
  currentRole: ProfitRole
  onClose: () => void
  onSelect: (role: ProfitRole) => void
  isPending: boolean
}

const ROLES: { id: ProfitRole; label: string; hint: string }[] = [
  { id: 'core', label: 'Core', hint: 'Hold-Forever — keine Profit-Trigger' },
  { id: 'satellite', label: 'Satellite', hint: 'Volle Trigger (Default)' },
  { id: 'single_stock', label: 'Single Stock', hint: 'Trigger nur wenn steuerfrei' },
]

export function RoleMoveModal({
  open,
  positionName,
  currentRole,
  onClose,
  onSelect,
  isPending,
}: Props) {
  if (!open) return null
  return (
    <div
      role="dialog"
      aria-labelledby="move-modal-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md border border-hairline bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h4 id="move-modal-title" className="tracked-caps text-[10px] text-bernstein">
          Position verschieben
        </h4>
        <p className="mt-1 text-base text-ink">{positionName}</p>

        <div className="mt-4 flex flex-col gap-2">
          {ROLES.map((r) => (
            <button
              key={r.id}
              type="button"
              aria-label={r.label}
              disabled={isPending || r.id === currentRole}
              onClick={() => onSelect(r.id)}
              className="rounded border border-hairline px-4 py-3 text-left hover:bg-panel disabled:opacity-40"
            >
              <span className="text-sm text-ink">{r.label}</span>
              <span className="ml-2 font-mono text-xs text-muted">{r.hint}</span>
            </button>
          ))}
        </div>

        <button type="button" onClick={onClose} className="mt-4 text-sm text-muted hover:text-ink">
          Abbrechen
        </button>
      </div>
    </div>
  )
}
